export default __webpack_public_path__ + "static/money-control-8391a873dc4cb1824fe4ad15b94fe6fa.png";